import { Dashboard } from '@/features/dashboard/components/Dashboard'
import { Page } from '@/ui-kit'

export const DashboardPage = () => {
  return (
    <Page>
      <Dashboard />
    </Page>
  )
}

export default DashboardPage
